import { CompanyMembershipManager } from 'view/pages/profile/components/CompanyMembershipManager';
import { ProfileMainWrapper, FormWrapper } from 'view/pages/profile/commonStyled';

const CompanyMemberships = () => {
  return (
    <ProfileMainWrapper>
      <FormWrapper>
        <CompanyMembershipManager />
      </FormWrapper>
    </ProfileMainWrapper>
  );
};

export default CompanyMemberships;
